export default __webpack_public_path__ + "static/media/exclamation.2cb21454.svg";